import { render, staticRenderFns } from "./BookingProgress.vue?vue&type=template&id=4965f4ce"
import script from "./BookingProgress.vue?vue&type=script&lang=js"
export * from "./BookingProgress.vue?vue&type=script&lang=js"
import style0 from "./BookingProgress.vue?vue&type=style&index=0&id=4965f4ce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports